import {
  Background,
  Controls,
  Edge,
  Node,
  ReactFlow,
  useEdgesState,
  useNodesState
} from '@xyflow/react';
import React from 'react';
import '@xyflow/react/dist/style.css';

interface EntityRelationshipDiagramProps {
  nodes: Node[];
  edges: Edge[];
  nodeTypes: any;
}

export function EntityRelationshipDiagram( { nodes, edges, nodeTypes }: EntityRelationshipDiagramProps ) {
  const [ localNodes, setLocalNodes, onNodesChange ] = useNodesState( nodes );
  const [ localEdges, setLocalEdges, onEdgesChange ] = useEdgesState( edges );

  // Update local nodes/edges when props change
  React.useEffect( () => {
    setLocalNodes( nodes );
  }, [ nodes, setLocalNodes ] );

  React.useEffect( () => {
    setLocalEdges( edges );
  }, [ edges, setLocalEdges ] );

  return (
    <div style={ { width: '100%', height: '600px' } }>
      <ReactFlow
        nodes={ localNodes }
        edges={ localEdges }
        onNodesChange={ onNodesChange }
        onEdgesChange={ onEdgesChange }
        nodeTypes={ nodeTypes }
        fitView
        minZoom={ 0.1 }
        maxZoom={ 1.5 }
      >
        <Background />
        <Controls />
      </ReactFlow>
    </div>
  );
}
